// =============================================================================
// Unified Notification Subscription Service - realtime projet/chat/docs
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

type NotificationChangePayload = {
  source: 'project' | 'chat' | 'doc';
  eventType: 'INSERT' | 'UPDATE' | 'DELETE';
  row?: Record<string, unknown>;
};

export function subscribeToUnifiedNotificationChanges(
  orgId: string,
  onChange: (payload: NotificationChangePayload) => void,
): () => void {
  const channel = supabase
    .channel(`notifications-unified:${orgId}`)
    .on('postgres_changes', { event: '*', schema: 'public', table: 'project_notifications' }, (payload) => {
      const row = (payload.new ?? payload.old) as Record<string, unknown> | undefined;
      if (row?.org_id !== orgId) return;
      onChange({ source: 'project', eventType: payload.eventType, row });
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'chat_notifications' }, (payload) => {
      const row = (payload.new ?? payload.old) as Record<string, unknown> | undefined;
      if (row?.org_id !== orgId) return;
      onChange({ source: 'chat', eventType: payload.eventType, row });
    })
    .on('postgres_changes', { event: '*', schema: 'public', table: 'docs_notifications' }, (payload) => {
      const row = (payload.new ?? payload.old) as Record<string, unknown> | undefined;
      if (row?.org_id !== orgId) return;
      onChange({ source: 'doc', eventType: payload.eventType, row });
    })
    .subscribe((status, err) => {
      // Realtime auto-retries on CHANNEL_ERROR/TIMED_OUT; log only in debug
      // mode to avoid noisy console warnings during transient reconnects.
      if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
        if (import.meta.env.DEV) {
          console.debug('[Notifications Realtime] transient status:', status, err ?? '');
        }
      }
    });

  return () => {
    supabase.removeChannel(channel);
  };
}